var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpMaxpool2D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 100,
    width: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 0.0000064941405,
    x: -2.3455812e-7,
    height: 26.458334,
    width: 26.458334,
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 0.76186782,
    y: 19.462866
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.462866,
    x: 6.9955168,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 19.462866,
    x: 13.229167,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 19.462816,
    y: 19.462866
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.229224,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 6.9955168,
    y: 13.229224
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 13.229167,
    y: 13.229224
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.229224,
    x: 19.462816,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 0.76186782,
    y: 6.9956121
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.9956121,
    x: 6.9955168,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.9956121,
    x: 13.229167,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 19.462816,
    y: 6.9956121
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.76196939,
    x: 0.76186782,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 6.9955168,
    y: 0.76196939
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 6.2336488,
    height: 6.2335243,
    x: 13.229167,
    y: 0.76196939
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.76196939,
    x: 19.462816,
    height: 6.2335243,
    width: 6.2336488,
    style: {
      fill: "#a5a5a5",
      fillOpacity: 1,
      stroke: "#909090",
      strokeWidth: 0.529167,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.05833,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.4,
    height: 25.400002,
    x: 0.52916694,
    y: 0.52915078,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 12.677838,
    height: 25.400002,
    x: 13.251328,
    y: 0.52915078,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 25.4,
    height: 12.720511,
    x: 0.52916694,
    y: 13.208642,
    ry: 0
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpMaxpool2D);
export default __webpack_public_path__ + "static/media/op-maxpool2d.ab25f19833e38d7d4e03a27dbbb11550.svg";
export { ForwardRef as ReactComponent };